<template>
    <div>

        <v-card elevation="7">
            <v-tabs v-model="sdk_tabs">
                <v-tab>Javascript SDK</v-tab>
                <v-tab>Php SDK</v-tab>
                <v-tab>Android SDK</v-tab>
                <v-tab>WordPress Puglin</v-tab>
            </v-tabs>
            <v-tabs-items v-model="api_tabs" style="padding: 15px">
                <v-tab-item></v-tab-item>
                <v-tab-item></v-tab-item>
                <v-tab-item></v-tab-item>
                <v-tab-item></v-tab-item>

            </v-tabs-items>

        </v-card>
    </div>
</template>

<script>
    import helpers from "../../../../mixins/helpers";

    export default {
        name: "DeveloperApi",
        mixins: [helpers(this)],
        data() {
            return {
                api_tabs: null,
                sdk_tabs: null,
                types: ['Places to Be', 'Places to See'],
                cards: ['Good', 'Best', 'Finest'],
                socials: [
                    {
                        icon: 'mdi-facebook',
                        color: 'indigo',
                    },
                    {
                        icon: 'mdi-linkedin',
                        color: 'cyan darken-1',
                    },
                    {
                        icon: 'mdi-instagram',
                        color: 'red lighten-3',
                    },
                ],
            }
        },
        computed: {
            keys: function () {
                return JSON.parse(sessionStorage.getItem("keys"))
            },
        },
        mounted() {
        },
        created() {
            this.checkisDashboard();
        },
        methods: {
            copy(text) {
                this.$copyText(text).then(function (e) {
                    alert('Copied')
                    console.log(e)
                }, function (e) {
                    alert('Can not copy')
                    console.log(e)
                })
            },
            getImage () {
                const min = 550
                const max = 560

                return Math.floor(Math.random() * (max - min + 1)) + min
            },
        },
    }

</script>

<style scoped>

    .circle-icon {
        background: #29B3A6;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-top: -30%;
        margin-left: 53%;
    }

    .circular--square {
        border-radius: 50%;
    }

    .circular--square {
        border-radius: 50% 50%;
        width: 170px;
        height: 170px;
        object-fit: contain;
    }

    .img-icon-holder {
        margin-left: 60%;
        padding: 8px;
        background-color: #29B3A6;
        border-radius: 50%;
    }

    /*.circular--portrait {
        position: relative;
        width: 200px;
        height: 200px;
        overflow: hidden;
        border-radius: 50%;
    }

    .circular--portrait img {
        width: 100%;
        height: auto;
    }*/
    .v-sheet.v-toolbar:not(.v-sheet--outlined), .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
        border: none !important;
    }
</style>
